import { render, staticRenderFns } from "./RepairsList.vue?vue&type=template&id=592a6750&scoped=true&"
import script from "./RepairsList.vue?vue&type=script&lang=js&"
export * from "./RepairsList.vue?vue&type=script&lang=js&"
import style0 from "./RepairsList.vue?vue&type=style&index=0&id=592a6750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a6750",
  null
  
)

export default component.exports